import selectAutoWidth from '../directives/selectAutoWidth';
import tableHeadFix from '../directives/tableHeadFix' ;
import entirePlaceholder from '../directives/entirePlaceholder';

export default {
    'select-auto-width': selectAutoWidth,
    'table-head-fix': tableHeadFix,
    'entire-placeholder': entirePlaceholder,
};



// WEBPACK FOOTER //
// ./src/directives/index.js